import { createFileRoute, Navigate, redirect } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { InvoiceOrderPage } from "@/features/admin/orders/InvoiceOrderPage";
import { fetchFeatureFlags } from "@/hooks/useFeatureFlags";
import { usePermissions } from "@/hooks/usePermissions";

export const Route = createFileRoute("/admin/orders_/$orderId")({
  // Invoice orders are hidden while the payments or seat-orders flag is off (the API 404s them too).
  beforeLoad: async () => {
    const { payments, seatOrders } = await fetchFeatureFlags();
    if (!payments || !seatOrders) throw redirect({ to: "/admin" });
  },
  component: InvoiceOrderRoute,
  remountDeps: ({ params }) => params.orderId,
});

/** One invoice order, its history, and moving it on (LMS-151). */
function InvoiceOrderRoute() {
  const { orderId } = Route.useParams();
  const { hasPermission } = usePermissions();

  return (
    <ProtectedRoute requiredPermissions={["Orders.Manage"]} requiredRoles={["SuperAdmin"]}>
      {hasPermission("Orders.Manage") ? (
        <AdminPageLayout mainClassName="bg-secondary_alt">
          <InvoiceOrderPage orderId={orderId} />
        </AdminPageLayout>
      ) : (
        <Navigate to="/admin" />
      )}
    </ProtectedRoute>
  );
}
